<template>
  <p class="c-text--disclaimer">
    MITRE does not assign scores, rankings, or ratings. The evaluation results are
    available to the public, so other organizations may provide their own analysis and
    interpretation - these are not endorsed or validated by MITRE.
    <span v-if="route.path.includes('deceptions')">
      As is the case with all ATT&CK Evaluations, the tools used in this Evaluation were set
      to alert mode and preventative functions were turned off.
    </span>
  </p>
</template>

<script>
import { useRoute } from 'vue-router';
export default {
  name: 'Disclaimer',
  data() {
    return {
      route: useRoute(),
    }
  }
};
</script>
